import { PaginationRange } from './pagination-range';

export class PaginationData<T> {
  constructor(
    public data: T[],
    public paginationRange: PaginationRange
  ) {}
}
